import * as tokens from '@purpur/library/tokens';

type Tokens = typeof tokens;

// keeps only keys starting with Prefix, preserving literal key types
type PickByPrefix<T, Prefix extends string> = {
    [K in keyof T as K extends `${Prefix}${string}` ? K : never]: string;
};

const groupByPrefix = <Prefix extends string>(prefix: Prefix) => {
    const entries = Object.entries(tokens).filter(
        ([key, value]) => key.startsWith(prefix) && typeof value === 'string',
    );

    return Object.fromEntries(entries) as PickByPrefix<Tokens, Prefix>;
};

export const purpurBorderVariables = groupByPrefix('purpurBorder');
export const purpurBreakpoints = groupByPrefix('purpurBreakpoint');
export const purpurColorVariables = groupByPrefix('purpurColor');
export const purpurMotionVariables = groupByPrefix('purpurMotion');
export const purpurShadowVariables = groupByPrefix('purpurShadow');
export const purpurSpacingVariables = groupByPrefix('purpurSpacing');
export const purpurTypographyVariables = groupByPrefix('purpurTypography');
